import { rest, isApiError } from 'services'
import { getShoppingData } from 'actions/shoppingData'


export const getTAOSAppointmentDatesAndSlots = (setAppointmentDataLoading, calendarStartDate) =>
  (dispatch) => {
    const availableDate = calendarStartDate || undefined

    return dispatch(getShoppingData(rest.api.getTAOSAppointmentDatesAndSlots, {
      isFromOnlineAppointment: false,
      availableDate
    })).catch(err => {
      setAppointmentDataLoading(false)
      if (isApiError(err)) {
        console.error(err)
      }
    })
  }
